module.exports = __webpack_public_path__ + "static/img/squadronAlarm-accept.71e1e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squadronAlarm-accept.png
// module id = Ovij
// module chunks = 208